import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Divider, message } from "antd";
import MainWrapper from "../components/MainWrapper";
import TransactionInfoCard from "../components/TransactionInfoCard";
import QrisLogo from "../assets/qrisLogo.svg";
import WalletTrue from "../assets/walletTrue.png";
import Prompt from "../assets/prompt.png";
import expiredQr from "../assets/expiredQr.png";
import { useSelector, useDispatch } from "react-redux";
import getQrManualCheck from "../redux/actions/getQrManualCheck";
import SuccessMessage from "../components/SuccessMessage";
import { language } from "../utils/language";
import { toLocaleStringFormate } from "../helpingFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { checkIdrCreatedTransaction } from "../redux/actions/postQrInitManual";
import PapayaLogo from "../assets/PAPAYA_LOGO.svg";

const CardWrapper = styled.div`
  // height: 750px;
  width: ${(props) => props.idrType};
  z-index: 999 !important;
  background-color: white;
  border-radius: 10px;

  height: auto;
  @media (min-width: 280px) and (max-width: 768px) {
    height: auto;
    margin-top: 10%;
    width: 90%;
  }

  .card_header {
    /* background-color: #133666; */
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px 10px 0 0;
  }
  .card_footer hr {
    background-color: black;
  }
  .baht_amount {
    // font-size: 18px;
    font-weight: bold;
  }
  .amount_sec {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .timer_sec {
    color: red;
    text-align: center;
  }
  .timer_sec span {
    font-size: 16px;
    font-weight: 600;
  }
  .success_message {
    font-size: 18px;
    color: green;
    font-weight: bold;
  }
`;

const IdrQrCardInfo = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const [minutes, setMinutes] = useState(15);
  const [seconds, setSeconds] = useState(0);
  const [confirmQrManualData, setConfirmQrManualData] = useState(null);

  const verifyManualTransactionState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { data: verfiyManualData } = verifyManualTransactionState;

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { modalShow, data: modalShowData } = warningModalState;

  const { data: qrManualCheckData } = useSelector(
    (state) => state.getQrManualCheckReducer
  );

  const { data } = useSelector((state) => state.postQrInitManualReducer);

  const { link } = useSelector((state) => state.getRedictionalUrl); //Get rediction link from reducer

  const [expiredQrImage, setExpiredQrIamge] = useState(false);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
      // dispatch(
      //   checkIdrCreatedTransaction(
      //     verfiyManualData.trxRef,
      //     verfiyManualData.merchantId
      //   )
      // );
    }, 1000);

    if (
      qrManualCheckData.status == "02_Paid" ||
      qrManualCheckData.status == "03_Rejected" ||
      (minutes == 0 && seconds == 0)
    ) {
      clearInterval(myInterval);
    }
    return () => {
      clearInterval(myInterval);
    };
  });

  useEffect(() => {
    let apiCallInterval = setInterval(() => {
      dispatch(
        checkIdrCreatedTransaction(
          verfiyManualData.trxRef,
          verfiyManualData.merchantId
        )
      );
    }, 3000);

    if (qrManualCheckData.status == "03_Rejected") {
      message.error("Your QR Code has been expired", 5);
      clearInterval(apiCallInterval);
      setExpiredQrIamge(true);
      if (link !== undefined && link !== "") {
        window.open(`${link}`, "_blank");
      } else {
        window.open(`${verfiyManualData?.siteUrl}`, "_blank");
      }
    } else if (
      qrManualCheckData.status == "02_Paid" ||
      qrManualCheckData.status == "03_Rejected" ||
      (minutes == 0 && seconds == 0)
    ) {
      clearInterval(apiCallInterval);
      setConfirmQrManualData(qrManualCheckData);
    }

    return () => {
      clearInterval(apiCallInterval);
    };
  }, [qrManualCheckData]);

  useEffect(() => {
    if (data == "") {
      navigate(`/idromp/${params.id}`);
    }
  }, [data]);


  useEffect(() => {
    if (qrManualCheckData && qrManualCheckData.status == "02_Paid") {
      setTimeout(() => {
        if (link) {
          window.open(`${link}`, "_blank");
        } else {
          window.open(`${verfiyManualData?.siteUrl}`, "_blank");
        }
      }, 1000);
    }
  }, [qrManualCheckData]);

  return (
    // <div>
    <MainWrapper>
      <CardWrapper
        idrType={params.idrType == "qris" || expiredQrImage ? "350px" : "80%"}
        expiredQrImage={expiredQrImage}
      >
        <div className="card_header">
          <img
            src={PapayaLogo}
            width={40}
            height={40}
            className="w-100 mt-4 d-flex justify-content-center"
          />
        </div>
        <div className="qr_code pt-3">
          {confirmQrManualData?.status === "02_Paid" ? (
            <SuccessMessage />
          ) : expiredQrImage === true || data.qrUrl === undefined ? (
            <img src={expiredQr} width="100%" height="80%" />
          ) : (
            <div style={{ height: params.idrType === "va" ? "100vh" : "90vh" }}>
              <img
                src={data.qrUrl}
                width={"100%"}
                height="100%"
                style={{ borderRadius: 10 }}
              />
              {/* <iframe
                src={data.qrUrl}
                width={"100%"}
                height="100%"
                style={{ borderRadius: 10 }}
              ></iframe> */}
            </div>
          )}
        </div>
      </CardWrapper>
      <p
        className="mt-2 text-center"
        style={{
          color: "#fff",
          fontSize: 16,
          fontFamily: "HarmonyRegular",
          fontWeight: 200,
        }}
      >
        © {new Date().getFullYear} Papaya Pay All Rights Reserved
      </p>
    </MainWrapper>
    //  {/* </div> */}
  );
};

export default IdrQrCardInfo;
